<!--
    Summary:
        我的
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-hover-box">
    <div class="main">
      <slot></slot>
    </div>
    <div v-if="showShader" class="shader" style="background-color: rgba(0,0,0,0.5);"></div>
    <div class="hover hover-content">
      <slot name="hover"></slot>
    </div>
    <div class="hover hover-bg" :style="{ 'background': background }"></div>
  </div>
</template>

<script>
  export default {
    name:"hover-box",
    props:{
      background:{
        type: String,
        default: "#ccc"
      },
      showShader: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-hover-box {
    position: relative;
    color: white;
    font-size: 16px;
    letter-spacing: 1px;
    .main{
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      position: relative;
      img{
        width: 100%;
      }
      .main-text{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        z-index: 2;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        text-transform: none;
      }
    }

    &:hover{
      .hover-content{
        opacity: 1;
      }
      .hover-bg{
        opacity: .9;
      }
    }
    .hover-content{
      z-index: 5;
    }
    .hover-bg{
      z-index: 4;
    }
    .hover{
      transition: opacity .5s;
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;


      padding: 0 30px;
      font-weight: 700;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .shader{
      transition: opacity .5s;
      opacity: 1;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hover-box.vue